
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-faculty",
      function () {
        return require("private-next-pages/our-faculty/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-faculty"])
      });
    }
  